<template>
    <div class="row justify-content-center align-items-center vh-100 w-100 m-0">
        <div class="col-12 row justify-content-center align-items-center p-0">
            <div class="col-12 col-md-10 col-lg-8 col-xxl-6 p-5 my-4 form-box">
                <h1>{{ $t("maintenance.title") }}</h1>
                <p class="mt-3">{{ $t("maintenance.info") }}</p>
                <form class="mt-5" @submit.prevent="verify()">
                    <h2>{{ $t("maintenance.adminTitle") }}</h2>
                    <input v-model="password" type="password" class="form-control form-control-lg mt-3"
                        :placeholder="$t('maintenance.password')" autocomplete="off">
                    <p v-if="error" class="text-danger mt-2">{{ error }}</p>
                    <button type="submit" class="p-2 mt-3 btn btn-lg btn-primary w-100 form-submit"
                        :disabled="!password || loading">
                        {{ $t("maintenance.submit") }}
                    </button>
                </form>
                <router-link :to="{ name: 'logout' }" class="d-block mt-4">{{ $t("maintenance.logout") }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: "",
            error: null,
            loading: false
        }
    },
    created() {
        if (!this.$store.getters.maintenance) {
            this.$router.push({ name: "dashboard" });
        }
    },
    methods: {
        verify() {
            this.loading = true;
            this.error = null;
            this.$store.getters.api.post("/maintenance", { password: this.password }).then(() => {
                this.$store.commit("setMaintenance", false);
                const path = this.$cookies.get("pathRedirect");
                if (path) {
                    this.$cookies.remove("pathRedirect");
                    return this.$router.push({ path: path });
                }
                this.$router.push({ name: "dashboard" });
            }).catch((error) => {
                if (error.response && error.response.data && error.response.data.error_code) {
                    this.error = this.$t("error." + error.response.data.error_code);
                }
                else {
                    this.error = this.$t("error.undefined");
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>
